import React, { useEffect, useState } from "react";
import { Button, Col, Modal, notification, Row, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { CensusShopService } from "../../../../../Services";
import UniqueValuesList from "./UniqueValueList";
import SelectFilterType from "./SelectFilterType";
import FilterForm from "./Filters Form";
import { formatKey } from "../../../Service";

export const AddNewFilter = ({ circle, loading, filterKeys, tenantName, section, refetchSections, mode, filter }) => {
	const [visible, setVisible] = useState(false);
	const [uniqueValueLoading, setUniqueValueLoading] = useState(false);
	const [uniqueValues, setUniqueValues] = useState(null);
	const [selectedFilterType, setSelectedFilterType] = useState(null);
	const [parentType, setParentType] = useState("Normal");
	const [selectedKey, setSelectedKey] = useState(parentType === "recursive" ? [] : null);

	const uniqueValueCallback = async selectedKey => {
		try {
			setUniqueValueLoading(true);
			const { data } = await CensusShopService.getKeyUniqueValues({
				key: selectedKey,
				tenantName
			});
			if (mode === "Add") setSelectedFilterType(null);

			const values = data.map(item => {
				const mapping = {
					null: "null",
					undefined: "undefined",
					false: "false"
				};
				return mapping[item] !== undefined ? mapping[item] : `${item}`;
			});

			setUniqueValues(values);
		} catch (e) {
			notification.error({
				message: "Error",
				description: e.message || "Something went wrong"
			});
		} finally {
			setUniqueValueLoading(false); // Ensure this runs even if there's an error
		}
	};

	useEffect(() => {
		if (mode === "Add") {
			setSelectedKey(null);
			setUniqueValues(null);
			setSelectedFilterType(null);
			setParentType(null);
			return;
		}

		if (mode === "Update") {
			setVisible(true);
			setSelectedKey(filter?._Type);
			setSelectedFilterType(filter?._Type);
			setUniqueValues(filter?.values);
			if (filter?._ApiTag) {
				uniqueValueCallback(filter?._ApiTag);
			}
			if (filter?._Type === "recursive") {
				setSelectedKey(filter?._Childrens.map(child => child._ApiTag));
				setParentType("recursive");
				return;
			}
			setSelectedKey(filter?._ApiTag);
			setParentType("Normal");
		}
	}, [mode]);
	return (
		<>
			{mode !== "Update" && (
				<Button
					loading={loading}
					type="primary"
					shape={`${circle ? "circle" : ""}`}
					icon={circle ? <PlusOutlined /> : null}
					onClick={() => setVisible(true)}
				>
					{mode === "Add" ? !circle && "Add New Filter" : "Update"}
				</Button>
			)}
			{visible && (
				<Modal open={visible} onCancel={() => setVisible(false)} width={550} title="Add New Filter">
					<Row gutter={[20, 20]} align={"middle"} justify={"center"}>
						<Col span={24}>
							<h4>Select Type</h4>
							<Select
								placeholder="Select Filter Type"
								style={{ width: "100%" }}
								value={parentType}
								onChange={value => {
									setParentType(value);

									setSelectedKey(value === "recursive" ? [] : null);
									setUniqueValues(null);
									setSelectedFilterType(null);
								}}
							>
								{["Normal", "recursive"].map(key => (
									<Select.Option key={key} value={key}>
										{formatKey(key)}
									</Select.Option>
								))}
							</Select>
						</Col>
						<Col span={24}>
							<Select
								showSearch
								mode={parentType === "recursive" ? "multiple" : "default"}
								maxTagCount={3}
								value={selectedKey}
								placeholder="Select Filter Key To Proceed"
								style={{ width: "100%" }}
								loading={loading || uniqueValueLoading}
								disabled={loading || uniqueValueLoading}
								onChange={value => {
									setSelectedKey(value);
									setUniqueValues(null);
									setSelectedFilterType(null);
								}}
							>
								{filterKeys
									.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))
									.map(key => (
										<Select.Option key={key} value={key}>
											{key}
										</Select.Option>
									))}
							</Select>
						</Col>
						<Col span={24} hidden={parentType === "recursive" || !selectedKey}>
							<Row justify="center">
								<Button
									loading={uniqueValueLoading}
									disabled={!selectedKey}
									type="primary"
									onClick={async () => {
										await uniqueValueCallback(selectedKey);
									}}
								>
									Get Values For {selectedKey}
								</Button>
							</Row>
						</Col>

						<Col span={24} hidden={!uniqueValues || parentType === "recursive"}>
							<UniqueValuesList data={uniqueValues || []} />
						</Col>

						<Col span={24} hidden={!uniqueValues || parentType === "recursive"}>
							<SelectFilterType
								uniqueValues={uniqueValues}
								selectedFilterType={selectedFilterType}
								setSelectedFilterType={setSelectedFilterType}
							/>
						</Col>

						<Col
							span={24}
							hidden={parentType === "recursive" ? false : !selectedFilterType || uniqueValueLoading}
						>
							<FilterForm
								mode={mode}
								filter={filter}
								closeForm={() => {
									setSelectedFilterType(null);
									setSelectedKey(null);
									setUniqueValues(null);
									setParentType(null);
									setVisible(false);
									refetchSections();
								}}
								section={section}
								selectedFilterType={parentType === "recursive" ? "recursive" : selectedFilterType}
								selectedKey={selectedKey}
								uniqueValues={uniqueValues}
							/>
						</Col>
					</Row>
				</Modal>
			)}
		</>
	);
};

export default AddNewFilter;
